import script from "./AfterSaleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AfterSaleManagement.vue?vue&type=script&setup=true&lang=js"

import "./AfterSaleManagement.vue?vue&type=style&index=0&id=64125bc2&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64125bc2"]])

export default __exports__